import { connect } from 'react-redux';
import { deleteInventoryItemSku } from '../../../redux/Inventory/sagas/item/routines';
import { deleteInventoryPackageSku } from '../../../redux/Inventory/sagas/package/routines';
import {
  getIsDeleting as getIsDeletingItem,
  getIsDeleted as getIsDeletedItem
} from '../../../redux/Inventory/selectors/item/skus';
import {
  getIsDeleting as getIsDeletingPackage,
  getIsDeleted as getIsDeletedPackage
} from '../../../redux/Inventory/selectors/package/skus';
import InventoryItemSkus from '../../../components/inventory/ItemSkus';
import { ItemType } from '../../../constants/inventory/InventoryTypes';

function mapStateToProps(state, props) {
  return {
    ...props,
    isDeletingItem: getIsDeletingItem(state),
    isDeletedItem: getIsDeletedItem(state),
    isDeletingPackage: getIsDeletingPackage(state),
    isDeletedPackage: getIsDeletedPackage(state)
  };
}

function mapDispatchToProps(dispatch, { type }) {
  return {
    onDeleteSku: ({ itemId: id, sku, id: skuId }) => {
      if (type === ItemType)
        dispatch(deleteInventoryItemSku({ id, sku, skuId }));
      else dispatch(deleteInventoryPackageSku({ id, sku, skuId }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryItemSkus);
